import { Typography } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { gridRowGroupingModelSelector, useGridApiContext } from "@mui/x-data-grid-premium";
import type {
  TabularDataCell,
  TabularRow,
  TabularSubtotalLabelPosition,
} from "../../../../../../../api/types/svTypes.ts";
import {
  getCellForSubtotal,
  getFieldNameFromGroupingColumnByFieldGuid,
  getSubtotalLabel,
} from "./utils/tabularGridDataProviderHelper.ts";

interface Props {
  params: GridRenderCellParams<TabularRow, TabularDataCell>;
  subtotalLabelPosition: TabularSubtotalLabelPosition;
  subtotalLabelFormatPrefix: string;
  subtotalLabelFormatSuffix: string;
}

export const MultipleColumnModeGroupingTotalCell = ({
  params,
  subtotalLabelPosition,
  subtotalLabelFormatPrefix,
  subtotalLabelFormatSuffix,
}: Props) => {
  const apiRef = useGridApiContext();
  const fieldName = getFieldNameFromGroupingColumnByFieldGuid(params.field);
  const rowGroupingModel = gridRowGroupingModelSelector(apiRef);
  const cell = getCellForSubtotal(apiRef, subtotalLabelPosition, rowGroupingModel, fieldName, params);

  if (!cell) {
    return null;
  }

  return (
    <Typography variant="subtitle2" sx={{ ml: "46px" }}>
      {getSubtotalLabel(cell, subtotalLabelFormatPrefix, subtotalLabelFormatSuffix)}
    </Typography>
  );
};

export default MultipleColumnModeGroupingTotalCell;
